import React from 'react';
import './style.css';

// 图标类型
export type IconName =
  | 'eos-icons:loading'
  | 'mdi:syllabary-hiragana'
  | 'tabler:letter-a'
  | 'mdi:translate'
  | 'heroicons-solid:switch-horizontal'
  | 'uil:text-size'
  | 'ph:check-bold'
  | 'mdi:close'
  | 'mdi:google-translate'
  | 'carbon:machine-learning'
  | 'ph:moon-stars'
  | 'ph:sun'
  | 'ph:speaker-high-fill'
  | 'ph:speaker-high'
  | 'mdi:format-font-size-decrease'
  | 'mdi:format-size'
  | 'mdi:format-font-size-increase'
  | 'ph:caret-up'
  | 'ph:caret-down'
  | 'mdi:cog'
  | 'mdi:chevron-left'
  | 'mdi:chevron-right'
  | 'mdi:content-copy';

interface IconSvgProps {
  name: IconName;
  width?: number | string;
  height?: number | string;
  className?: string;
  onClick?: () => void;
}

export const IconSvg: React.FC<IconSvgProps> = ({
  name,
  width = 24,
  height = 24,
  className = '',
  onClick
}) => {
  // 统一处理宽高
  const size = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
  };

  // 图标渲染函数
  const renderIcon = () => {
    switch (name) {
      case 'eos-icons:loading':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <g className="icon-loading">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" strokeOpacity="0.2" />
              <path
                d="M12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893"
                stroke="currentColor"
                strokeWidth="3"
                fill="none"
                strokeLinecap="round"
              />
            </g>
          </svg>
        );

      case 'mdi:syllabary-hiragana':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M9 4v2H6v2h3v2c-2.75 0-5 2.27-5 5.03a5.04 5.04 0 0 0 5.03 5.03c.86 0 1.69-.29 2.37-.8c.23.28.48.56.75.83l1.41-1.42c-.26-.25-.49-.52-.7-.78l1-1c1.07-1.07 1.92-2.66 2.56-4.3c.89.52 1.58 1.31 1.58 2.41c0 1.32-.53 2.6-1.46 3.54l1.41 1.41A7 7 0 0 0 20 15c0-1.96-1.18-3.64-2.85-4.45l.35-1.26l-1.95-.51l-.34 1.27c-.08 0-.15-.05-.24-.05H11V8h5V6h-5V4m0 8h3.5c-.56 1.37-1.31 2.72-2.06 3.47l-.65.66c-.54-1.2-.79-2.54-.79-4.13m-2 0c0 2.07.41 3.94 1.3 5.59c-.36.3-.8.47-1.27.47c-1.7 0-3.03-1.33-3.03-3.03C6 13.34 7.32 12 9 12" />
          </svg>
        );

      case 'tabler:letter-a':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 20V8a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v12m-8-4h8" />
          </svg>
        );

      case 'mdi:translate':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="m12.87 15.07l-2.54-2.51l.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v2h11.17C11.5 7.92 10.44 9.75 9 11.35C8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5l3.11 3.11l.76-2.04M18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12m-2.62 7l1.62-4.33L19.12 17h-3.24Z" />
          </svg>
        );

      case 'heroicons-solid:switch-horizontal':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M8 5a1 1 0 1 0 0 2h5.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L13.586 5zm4 10a1 1 0 1 0 0-2H6.414l1.293-1.293a1 1 0 1 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L6.414 15z" />
          </svg>
        );

      case 'uil:text-size':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M9 11H3a1 1 0 0 0 0 2h2v5a1 1 0 0 0 2 0v-5h2a1 1 0 0 0 0-2m12-6H9a1 1 0 0 0 0 2h5v11a1 1 0 0 0 2 0V7h5a1 1 0 0 0 0-2" />
          </svg>
        );

      case 'ph:check-bold':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="m232.49 80.49l-128 128a12 12 0 0 1-17 0l-56-56a12 12 0 1 1 17-17L96 183l119.51-119.52a12 12 0 0 1 17 17Z" />
          </svg>
        );

      case 'mdi:close':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" />
          </svg>
        );

      case 'mdi:google-translate':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="m21 20l-6-4l3-1l-3-1l6-4M6 8a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0-2a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m0 10c.68 0 1.35-.1 2-.26c.61.69 1 1.56 1 2.5v.19C8.23 18.79 7.14 19 6 19c-1.15 0-2.24-.22-3-.63v-.19c0-.94.39-1.81 1-2.5c.65.17 1.32.26 2 .26m0-12C3.8 4 2 4.9 2 6v3c0 1.1 1.8 2 4 2s4-.9 4-2V6c0-1.1-1.8-2-4-2Z" />
          </svg>
        );

      case 'carbon:machine-learning':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M30 10h-7.101A4.998 4.998 0 0 0 18 6a4.998 4.998 0 0 0-4.899 4H2v12h2v7h16V22h10V10zm-12-2a3 3 0 1 1-3 3a3.003 3.003 0 0 1 3-3zm-8 19v-5h12v5H10z" />
          </svg>
        );

      case 'ph:moon-stars':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M240 96a8 8 0 0 1-8 8h-16v16a8 8 0 0 1-16 0v-16h-16a8 8 0 0 1 0-16h16V72a8 8 0 0 1 16 0v16h16a8 8 0 0 1 8 8Zm-96-40h8v8a8 8 0 0 0 16 0v-8h8a8 8 0 0 0 0-16h-8v-8a8 8 0 0 0-16 0v8h-8a8 8 0 0 0 0 16Zm72.77 97a8 8 0 0 1 1.43 8A96 96 0 1 1 95 37.8a8 8 0 0 1 9.49 9.49A88 88 0 0 0 216.77 153Z" />
          </svg>
        );

      case 'ph:sun':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M120 40V16a8 8 0 0 1 16 0v24a8 8 0 0 1-16 0Zm72 88a64 64 0 1 1-64-64a64.07 64.07 0 0 1 64 64Zm-16 0a48 48 0 1 0-48 48a48.05 48.05 0 0 0 48-48ZM58.34 69.66a8 8 0 0 0 11.32-11.32l-16-16a8 8 0 0 0-11.32 11.32Zm0 116.68l-16 16a8 8 0 0 0 11.32 11.32l16-16a8 8 0 0 0-11.32-11.32ZM192 72a8 8 0 0 0 5.66-2.34l16-16a8 8 0 0 0-11.32-11.32l-16 16A8 8 0 0 0 192 72Zm5.66 114.34a8 8 0 0 0-11.32 11.32l16 16a8 8 0 0 0 11.32-11.32ZM48 128a8 8 0 0 0-8-8H16a8 8 0 0 0 0 16h24a8 8 0 0 0 8-8Zm80 80a8 8 0 0 0-8 8v24a8 8 0 0 0 16 0v-24a8 8 0 0 0-8-8Zm112-88h-24a8 8 0 0 0 0 16h24a8 8 0 0 0 0-16Z" />
          </svg>
        );

      case 'ph:speaker-high-fill':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M155.51 24.81a8 8 0 0 0-8.42.88L77.25 80H32a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h45.25l69.84 54.31A8 8 0 0 0 160 224V32a8 8 0 0 0-4.49-7.19ZM200 199.3a8 8 0 0 1-12.5-10a79.79 79.79 0 0 0 0-122.6a8 8 0 0 1 12.5-10a95.53 95.53 0 0 1 .02 142.59Zm-32-21.61a8 8 0 0 1-12.5-10a47.9 47.9 0 0 0 0-79.38a8 8 0 0 1 12.5-10a63.9 63.9 0 0 1 0 99.38Z" />
          </svg>
        );

      case 'ph:speaker-high':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M155.51 24.81a8 8 0 0 0-8.42.88L77.25 80H32a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h45.25l69.84 54.31A8 8 0 0 0 160 224V32a8 8 0 0 0-4.49-7.19ZM144 207.36L84.91 160H32V96h52.91L144 48.64ZM200 199.3a8 8 0 0 1-12.5-10a79.79 79.79 0 0 0 0-122.6a8 8 0 0 1 12.5-10a95.53 95.53 0 0 1 .02 142.59Zm-32-21.61a8 8 0 0 1-12.5-10a47.9 47.9 0 0 0 0-79.38a8 8 0 0 1 12.5-10a63.9 63.9 0 0 1 0 99.38Z" />
          </svg>
        );

      case 'mdi:format-font-size-decrease':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M5.12 14L7.5 7.67L9.87 14M6.5 5L1 19h2.25l1.12-3h6.25l1.13 3H14L8.5 5h-2M18 17l5-5l-5-5v10Z" />
          </svg>
        );

      case 'mdi:format-size':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M2 4v7h2V6h4v12H6v2h8v-2h-2V6h4v5h2V4H2m18 3.12v2.38h-4.5v2.38h2.62c-.27 1.15-.52 1.82-1.13 2.62c-.36.45-.75.82-1.21 1.18l1.72 1.58c.86-.86 1.58-1.8 2.14-2.86c.56-1.05.92-2.14 1.17-3.76h1.69V7.12H20Z" />
          </svg>
        );

      case 'mdi:format-font-size-increase':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M5.12 14L7.5 7.67L9.87 14M6.5 5L1 19h2.25l1.12-3h6.25l1.13 3H14L8.5 5h-2M18 7l-5 5l5 5V7Z" />
          </svg>
        );

      case 'ph:caret-up':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`} fill="currentColor">
            <path d="M6.41 16L12 10.41L17.59 16L19 14.59L12 7.59L5 14.59L6.41 16Z" />
          </svg>
        );

      case 'ph:caret-down':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`} fill="currentColor">
            <path d="M6.41 8L12 13.59L17.59 8L19 9.41L12 16.41L5 9.41L6.41 8Z" />
          </svg>
        );

      case 'mdi:restore':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89l.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18" />
          </svg>
        );

      case 'mdi:cog':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M12 15.5A3.5 3.5 0 0 1 8.5 12A3.5 3.5 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5m7.43-2.53c.04-.32.07-.64.07-.97c0-.33-.03-.66-.07-1l2.11-1.63c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.31-.61-.22l-2.49 1c-.52-.39-1.06-.73-1.69-.98l-.37-2.65c-.04-.24-.25-.42-.5-.42h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.25-1.17.59-1.69.98l-2.49-1c-.22-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64L4.57 11c-.04.34-.07.67-.07 1c0 .33.03.65.07.97l-2.11 1.66c-.19.15-.25.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1.01c.52.4 1.06.74 1.69.99l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.63-.26 1.17-.59 1.69-.99l2.49 1.01c.22.08.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64z" />
          </svg>
        );

      case 'mdi:chevron-left':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        );

      case 'mdi:chevron-right':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        );

      case 'mdi:content-copy':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" />
          </svg>
        );

      default:
        // 默认图标或空图标
        return (
          <svg viewBox="0 0 24 24" {...size} className={`icon-svg ${className}`}>
            <path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2zM8 8l6 0v2H8zm0 4h8v2H8zm0 4h6v2H8z" />
          </svg>
        );
    }
  };

  return (
    <div className="icon-wrapper" onClick={onClick}>
      {renderIcon()}
    </div>
  );
};